(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('conexiones', {
            parent: 'entity',
            url: '/conexiones?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.conexiones.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conexiones/conexiones.html',
                    controller: 'ConexionesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conexiones');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('conexiones-detail', {
            parent: 'conexiones',
            url: '/conexiones/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.conexiones.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conexiones/conexiones-detail.html',
                    controller: 'ConexionesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conexiones');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Conexiones', function($stateParams, Conexiones) {
                    return Conexiones.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'conexiones',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('conexiones-detail.edit', {
            parent: 'conexiones-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conexiones.new', {
            parent: 'conexiones',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ip: null,
                                ultimafechaconexion: null,
                                ultimafechatx: null,
                                contadorconn: null,
                                contadortx: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('conexiones');
                });
            }]
        })
        .state('conexiones.edit', {
            parent: 'conexiones',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conexiones.delete', {
            parent: 'conexiones',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-delete-dialog.html',
                    controller: 'ConexionesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
